import React, { memo } from 'react'

// @mui material components

// Material Icons

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
//Gauge Chart

// react-countup components
import SoftButton from 'components/SoftButton'

//Accordion
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'

import {
  AllAssets,
  AllLiabilities,
  AllIncomes,
  AllExpenses,
  CSAssets,
  CreditCardLiabilities,
  InvestmentAssets,
  MortgageLiabilities,
  PropertyAssets,
  OtherAssets,
  OtherLiabilities,
  Deductions,
  TspLoans,
} from 'layouts/authenticated/pages/dashboard/components'
import { Box, Button } from '@mui/material'
import { Add } from '@mui/icons-material'
const dollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

const accountPropKey = (category) => {
  switch (category) {
    case CSAssets.targetCategory:
    case InvestmentAssets.targetCategory:
    case PropertyAssets.targetCategory:
    case OtherAssets.targetCategory:
    case 'AllAssets':
      return 'assets'
    case MortgageLiabilities.targetCategory:
    case CreditCardLiabilities.targetCategory:
    case TspLoans.targetCategory:
    case OtherLiabilities.targetCategory:
    case 'AllLiabilities':
      return 'liabilities'
    case 'AllIncomes':
      return 'incomes'
    case 'AllExpenses':
      return 'expenses'
    default:
      return 'deductions'
  }
}

export const BalanceSheetRow = memo(
  ({
    accounts: allAccountsOfType,
    handleAddAccount,
    handleViewAccount,
    category,
    accountType,
    addAccountButtonText,
    isDefaultExpanded = false,
    assetsWithTSP,
  }) => {
    const subTypeComponentMap = {
      [CSAssets.targetCategory]: CSAssets,
      [CreditCardLiabilities.targetCategory]: CreditCardLiabilities,
      [InvestmentAssets.targetCategory]: InvestmentAssets,
      [MortgageLiabilities.targetCategory]: MortgageLiabilities,
      [PropertyAssets.targetCategory]: PropertyAssets,
      [OtherAssets.targetCategory]: OtherAssets,
      [OtherLiabilities.targetCategory]: OtherLiabilities,
      [TspLoans.targetCategory]: TspLoans,
      ['AllLiabilities']: AllLiabilities,
      ['AllAssets']: AllAssets,
      ['AllIncomes']: AllIncomes,
      ['AllExpenses']: AllExpenses,
      [Deductions.targetCategory]: Deductions,
    }
    const AccountComponent = subTypeComponentMap[category]
    const assetType = accountPropKey(category)
    const accounts =
      category === 'AllLiabilities' ||
      category === 'AllAssets' ||
      category === 'AllIncomes' ||
      category === 'AllExpenses'
        ? allAccountsOfType || []
        : (allAccountsOfType || []).filter(
            (option) =>
              (category === 'deduction' ? option.type : option.subType) ===
              category
          )
    const accountSum =
      category === 'AllAssets'
        ? assetsWithTSP
        : accounts.map((assets) => assets.amount).reduce((a, b) => a + b, 0)

    // console.log(accounts)

    return (
      <Box>
        <Accordion
          defaultExpanded={isDefaultExpanded}
          sx={{
            boxShadow: 'none',
            '&.MuiPaper-root.MuiAccordion-root .MuiAccordionSummary-root': {
              padding: '0 12px 0 16px',
            },
            '&.MuiPaper-root.MuiAccordion-root.Mui-expanded': {
              boxShadow: 'none',
              marginTop: '0',
              backgroundColor: '#fafafb',
            },
            '.MuiAccordionSummary-root:hover': {
              backgroundColor: '#fafafb',
            },
            '.MuiAccordionSummary-root.Mui-expanded': {
              minHeight: '48px',
              backgroundColor: '#fafafb',
              borderTop: '1px solid #ddd',
            },
            '.MuiAccordionSummary-content': {
              margin: '12px 0',
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ borderTop: '1px solid #ddd' }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              width="100%"
              mr={1}
            >
              <SoftTypography
                textAlign="left"
                color="inherit"
                variant="body2"
                fontWeight="bold"
              >
                {accountType}
              </SoftTypography>
              <SoftTypography
                textAlign="right"
                color="inherit"
                variant="body2"
                fontWeight="bold"
              >
                {dollarFormat.format(accountSum)}
              </SoftTypography>
            </Box>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: '0 16px 16px',
            }}
          >
            <AccountComponent
              {...{ [assetType]: accounts }}
              handleOnClick={handleViewAccount}
            />
            <Button
              rel="noreferrer"
              onClick={handleAddAccount}
              startIcon={<Add />}
              sx={{
                padding: '8px 10px 7px',
                backgroundColor: '#E4F0FF',
                color: '#5D6D8E',
                border: '1px solid #ADC5E3',
                fontWeight: '500',
                width: '100%',
                boxShadow: 'none',
                fontSize: '18px',
                textTransform: 'capitalize',
                '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                  transform: 'none',
                  backgroundColor: '#cdd8e5',
                  color: '#5D6D8E',
                  boxShadow: 'none',
                },
                '&>span': {
                  margin: '0 4px 0 0',
                },
                '&>span>svg': {
                  fontSize: '1.5rem !important',
                },
              }}
            >
              {addAccountButtonText}
            </Button>
          </AccordionDetails>
        </Accordion>
      </Box>
    )
  }
)

BalanceSheetRow.displayName = 'BalanceSheetRow'
